<template>

  <div class="container">
      <div class="row justify-content-center  mt-4 ">
              <div class="col-10">
                
                <div class="row m-4">
                  <div class="col-4 text-center">
                    <i class='bx bx-loader text-warning fs-3'></i> - შეფასება ჯერ არ დაწერილა
                  </div>
                  <div class="col-4 text-center">
                    <i  class='bx bxs-x-circle text-danger fs-3' ></i> - შედეგი არ დადასტურდა
                  </div>
                  <div class="col-4 text-center">
                    <i  class='bx bxs-checkbox-checked text-success fs-1' ></i> - შედეგი დადასტურდა
                  </div>
                </div>
                  <div class="table-responsive tisch">
                   
                      <table class="table" v-if="evaluations.length>0">
    <thead>
      <tr class="color-bg">
        <th scope="col">#</th>
        <th scope="col">ლექტორი</th>
        <th scope="col">მოდული</th>
        <th scope="col">შედეგი</th>
      
      </tr>
    </thead>
    <tbody>
      <tr v-for="data of evaluations">
        <th scope="row">{{ data.groupN }}</th>
        <td>{{ data.fname }} {{data.lname  }}</td>
        <td>{{ data.module_name }}</td>
        <td style="font-size:40px" class="text-center">
          <i v-if="data.evaluation_typeID==null" class='bx bx-loader text-warning'></i>
          <i v-else-if="data.evaluation_typeID==0" class='bx bxs-x-circle text-danger' ></i>
          <i v-else class='bx bxs-checkbox-checked text-success' ></i>
         </td>
      </tr>
      
    </tbody>
  </table>
  
  
              </div>
  
  
      </div>
  </div>
  
  </div>
  
  </template>
  <script>
  import HttpRequests from '../httpRequests/httpRequests';
  const httpRequests=new HttpRequests()
  export default{
    data(){
      return{
      evaluations:[]
      }
    },
    mounted(){
  
  
      httpRequests.getEvaluations().then(response=>{
        this.evaluations=response.data
      })
  
    }
  }
  
  </script>